"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SearcherDatepicker = require("./SearcherDatepicker.desktop");
var _SearcherDatepicker2 = require("./SearcherDatepicker.mobile");
var SearcherDatepicker = function SearcherDatepicker(props) {
  var _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile;
  return isMobile ? /*#__PURE__*/_react["default"].createElement(_SearcherDatepicker2.SearcherDatepickerMobile, (0, _extends2["default"])({}, props, {
    isMobile: true
  })) : /*#__PURE__*/_react["default"].createElement(_SearcherDatepicker.SearcherDatepickerDesktop, props);
};
var _default = exports["default"] = SearcherDatepicker;